import { create } from "zustand";

interface CategorySummaryState {
  mainSelectedAnalysisId: string;
  compSelectedAnalysisId: string;
  mainSelectedCategoryPath: string;
  compSelectedCategoryPath: string;
  setMainSelectedAnalysisId: (id: string) => void;
  setCompSelectedAnalysisId: (id: string) => void;
  setMainSelectedCategoryPath: (path: string) => void;
  setCompSelectedCategoryPath: (path: string) => void;
}

export const useCategorySummaryStore = create<CategorySummaryState>()(
  (set) => ({
    mainSelectedAnalysisId: "",
    compSelectedAnalysisId: "",
    mainSelectedCategoryPath: "",
    compSelectedCategoryPath: "",
    setMainSelectedAnalysisId: (id: string) => set((_) => ({ mainSelectedAnalysisId: id })),
    setCompSelectedAnalysisId: (id: string) => set((_) => ({ compSelectedAnalysisId: id })),
    setMainSelectedCategoryPath: (path: string) => set((_) => ({ mainSelectedCategoryPath: path })),
    setCompSelectedCategoryPath: (path: string) => set((_) => ({ compSelectedCategoryPath: path })),
  }),
);
